/* eslint-disable react/jsx-closing-tag-location */
import React, { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import { Accordion } from 'react-accessible-accordion';

import Island from '../shared/Island';
import Navbar from '../shared/Navbar';
import FAQuestion from './FAQuestion';
import Footer from './Footer';
import Section from './Section';
import Title from '../shared/Title';
import Text from '../shared/Text';
import { palette, breakpoints } from '../../constants/styles';
import ScrollToTopOnMount from '../shared/ScrollToTopOnMount';
import CTAButton from '../shared/CTAButton';
import { mp } from '../../constants/utils';
import { getCampaign } from '../../constants/utils';
import {phoneNumber} from "../../constants/constants";

export const StyledFAQList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 750px;
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 0.5rem;
`;

const StyledCTACaption = css`
  max-width: 238px;
  margin-top: 0.5rem;
  margin-left: 0.2rem;

  ${breakpoints.tablet} {
    margin-left: 1rem;
    margin-top: 0.2rem;
  }
`;

const FAQs = [
  {
    id: 'finauta',
    name: 'Cafecín en...',
    questions: [
      {
        question: 'Monterrey',
        answer: (
          <StyledContent>
            <CTAButton
              icon="whatsapp"
              buttonText="Yo me apunto"
              externalLink={`https://api.whatsapp.com/send?phone=5218112886677&text=${encodeURIComponent(
                'Hola 👋</span> Yo me apunto para un cafecín en Monterrey',
              )}`}
              event="Cafecín | Monterrey | Yo me apunto"
            />
            <Text type="caption" align="left" styles={StyledCTACaption}>
              Al dar click en este botón se abrirá una conversación de WhatsApp con un integrante de
              nuestro equipo.
            </Text>
          </StyledContent>
        ),
        metric: 'Cafecin | Monterrey | Accordion',
      },
      {
        question: 'CDMX',
        answer: (
          <StyledContent>
            <CTAButton
              icon="whatsapp"
              buttonText="Yo me apunto"
              externalLink={`https://api.whatsapp.com/send?phone=5215528582472&text=${encodeURIComponent(
                'Hola 👋</span> Yo me apunto para un cafecín en CDMX',
              )}`}
              event="Cafecín | CDMX | Yo me apunto"
            />
            <Text type="caption" align="left" styles={StyledCTACaption}>
              Al dar click en este botón se abrirá una conversación de WhatsApp con un integrante de
              nuestro equipo.
            </Text>
          </StyledContent>
        ),
        metric: 'Cafecin | CDMX | Accordion',
      },
      {
        question: 'Otro estado',
        answer: (
          <StyledContent>
            <CTAButton
              icon="whatsapp"
              buttonText="Yo me apunto"
              externalLink={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
                'Hola 👋</span> Yo me apunto para un cafecín virtual',
              )}`}
              event="Cafecín | Resto de México | Yo me apunto"
            />
            <Text type="caption" align="left" styles={StyledCTACaption}>
              Al dar click en este botón se abrirá una conversación de WhatsApp con un integrante de
              nuestro equipo.
            </Text>
          </StyledContent>
        ),
        metric: 'Cafecin | OtroEstado | Accordion',
      },
    ],
  },
  {
    id: 'questions',
    name: 'Cuéntame más',
    questions: [
      {
        question: '¿Por qué quieren platicar conmigo?',
        answer: (
          <div style={{ marginTop: '0.5rem' }}>
            <Text
              type="body1"
              align="left"
              styles={css`
                margin-top: 0.5rem;
              `}
            >
              Por los últimos 6 - 8 meses hemos estado emprendiendo con la finalidad de ayudarle a
              profesionistas jóvenes en México a que logren sus metas financieras.
            </Text>
            <Text
              type="body1"
              align="left"
              styles={css`
                margin-top: 1rem;
              `}
            >
              Para enfocarnos en problemas reales, y no en los problemas que nosotros creemos
              existen queremos platicar con profesionistas jóvenes.
            </Text>
            <Text
              type="body1"
              align="left"
              styles={css`
                margin-top: 1rem;
              `}
            >
              Queremos caminar en sus zapatos, empatizar con su situación y así detectar problemas
              reales.
            </Text>
          </div>
        ),
        metric: 'Cafecin | CuentameMas | Por que',
      },
      {
        question: '¿Sobre qué platicaríamos?',
        answer: (
          <div style={{ marginTop: '0.5rem' }}>
            <Text
              type="body1"
              align="left"
              styles={css`
                margin-top: 0.5rem;
              `}
            >
              Primeramente platicaríamos un rato sobre finanzas personales.
            </Text>
            <Text
              type="body1"
              align="left"
              styles={css`
                margin-top: 1rem;
              `}
            >
              Posteriormente te enseñaremos lo que hemos desarrollado hasta ahora.
            </Text>
            <Text
              type="body1"
              align="left"
              styles={css`
                margin-top: 1rem;
              `}
            >
              Finalmente juntos recapitularemos las áreas de oportunidad del proyecto.
            </Text>
          </div>
        ),
        metric: 'Cafecin | CuentameMas | Sobre que',
      },
      {
        question: 'Quiero ayudar pero no me identifico con la descripción...',
        answer: (
          <div style={{ marginTop: '0.5rem' }}>
            <Text
              type="body1"
              align="left"
              styles={css`
                margin-top: 0.5rem;
              `}
            >
              Primero que nada, ¡muchas gracias por abrir esta pestaña!
            </Text>
            <Text
              type="body1"
              align="left"
              styles={css`
                margin-top: 0.5rem;
              `}
            >
              Nos puedes ayudar compartiendo esta página con tus amigos y familia
              <span role="img" aria-label="happy">
                😁
              </span>
            </Text>
          </div>
        ),
        metric: 'Cafecin | CuentameMas | No me identifico',
      },
    ],
  },
];

const StyledFAQ = styled.div`
  position: relative;
  overflow: hidden;
`;

const StyledCafesinSection = styled(Section)`
  min-height: 90vh;
  padding: 20px 40px 20px 40px;

  ${breakpoints.tablet} {
    margin-top: 20px;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 50px;
  }

  ${breakpoints.desktop} {
    margin-top: 90px;
  }
`;

const StyledUnderline = styled.span`
  text-shadow: 0px 0px white, 0px 0px white, 2px -2px white, 0px 0px white;
  background-size: 1px 1em;
  box-shadow: inset 0 -0.175em white, inset 0 -0.2em #000;
  display: inline;
  box-shadow: inset 0 -0em white, inset 0 -0.1em ${palette.secondaryColor};
  line-height: 1.65;
`;

class Cafecin extends Component {
  componentDidMount() {
    mp(getCampaign(window.location.href));
    mp('Cafecín');
    mp('Entra');
  }

  render() {
    return (
      <Fragment>
        <StyledFAQ>
          <ScrollToTopOnMount />

          <Navbar style={{ alignSelf: 'flex-start' }} />
          <StyledCafesinSection>
            <Title
              level={2}
              align="center"
              styles={css`
                line-height: 1.3;
              `}
            >
              Vamos por un cafecín
            </Title>
            <Text
              type="body1"
              align="left"
              styles={css`
                width: 100%;
                max-width: 615px;
                margin-bottom: 0rem;
                text-align: left;
              `}
              medium
            >
              Si esto suena como tú...
            </Text>
            <div style={{ width: '100%', maxWidth: '615px' }}>
              <ul style={{ paddingLeft: '0.5rem' }}>
                <li>
                  <Text
                    type="body1"
                    align="left"
                    styles={css`
                      margin-bottom: 0.5rem;
                    `}
                  >
                    Tienes entre 22 y 35 años
                  </Text>
                </li>
                <li>
                  <Text
                    type="body1"
                    align="left"
                    styles={css`
                      margin-bottom: 0.5rem;
                    `}
                  >
                    Actualmente estás laborando de tiempo completo
                  </Text>
                </li>
                <li>
                  <Text
                    type="body1"
                    align="left"
                    styles={css`
                      margin-bottom: 0.5rem;
                    `}
                  >
                    Cuentas con 30 minutos para contribuir a una buena causa
                  </Text>
                </li>
              </ul>
            </div>
            <Text
              type="body1"
              align="left"
              styles={css`
                max-width: 615px;
                margin-bottom: 1rem;
              `}
            >
              <StyledUnderline>
                Nos encantaría invitarte un cafecín
                <span role="img" aria-label="happy">
                  {' '}
                  ☕️
                </span>
              </StyledUnderline>
              , a la hora que puedas en el café de tu preferencia.
            </Text>
            <Text
              type="caption"
              align="left"
              styles={css`
                max-width: 615px;
                margin-bottom: 1rem;
              `}
            >
              Cafecín prescencial sólo disponible en Monterrey y CDMX. Para el resto de la república
              podemos llevar a cabo un cafecín virtual (videollamada).
            </Text>
            <StyledFAQList>
              {FAQs.map((section) => (
                <div id={section.id} style={{ width: '100%' }}>
                  <Title
                    level={4}
                    color={palette.terciaryColor}
                    styles={css`
                      margin-bottom: 0px;
                      margin-top: 20px;
                      align-self: flex-start;
                    `}
                  >
                    {section.name}
                  </Title>
                  <Accordion
                    accordion={false}
                    style={{ width: '100%', marginTop: '10px', maxWidth: '750px' }}
                  >
                    {section.questions.map((question) => (
                      <FAQuestion
                        event={question.metric}
                        question={question}
                        key={question.question}
                        expanded={question.expanded}
                      />
                    ))}
                  </Accordion>
                </div>
              ))}
            </StyledFAQList>
          </StyledCafesinSection>
          <Footer />
        </StyledFAQ>
      </Fragment>
    );
  }
}

export default Cafecin;
